// link_validations.js

export function validate_link(pattern, url) {
    if (url === "") {
        return true
    }
    // Reject URLs with spaces - they're never valid
    if (/\s/.test(url)) {
        return false;
    }
    switch (pattern) {
        case 'spotify_url':
            return /^https:\/\/open\.spotify\.com\/(episode|show)\/[a-zA-Z0-9]+(\?.*)?$/.test(url);

        case 'itunes_url':
            // Strict regex: https://podcasts.apple.com/{country}/podcast/{slug}/id{numbers}
            return /^https:\/\/podcasts\.apple\.com\/[a-z]{2}\/podcast\/[a-zA-Z0-9\-\%]+\/id\d+(\?.*)?$/.test(url);

        case 'amazon_url':
            // Title segment at the end is optional
            return /^https:\/\/music\.amazon\.[a-z.]+\/podcasts\/[a-f0-9-]+(\/episodes\/[a-f0-9-]+)?(\/[^\s\/]+)?(\?.*)?$/.test(url)

        case 'pandora_url':
            return /^https:\/\/(www\.pandora\.com\/podcast\/[a-z0-9\-]+\/PC:\d+(\/[a-z0-9\-]+\/PC:\d+)?|pandora\.app\.link\/[\w-]+)$/.test(url);

        case 'iheart_url':
            return /^https:\/\/www\.iheart\.com\/podcast\/\d+-[a-z0-9\-]+(\/episodes\/[a-z0-9\-]+-\d+)?\/$/.test(url)

        case 'castbox_url':
            return /^https:\/\/castbox\.fm\/(channel|episode)\/[a-zA-Z0-9\-\.]+-id\d+(?:\?.*)?$/.test(url)

        case 'pocket_casts_url':
            // Supports both pca.st short URLs and pocketcasts.com full URLs
            return /^https:\/\/(pca\.st\/(episode\/[a-f0-9\-]{36}|[a-z0-9]+)|pocketcasts\.com\/podcast\/[a-zA-Z0-9\-]+\/[a-f0-9\-]{36})$/.test(url)

        case 'podcast_addict_url':
            return /^https:\/\/podcastaddict\.com\/(podcast\/[a-z0-9\-]+\/\d+|[a-z0-9\-]+\/\d+)$/.test(url)

        case 'overcast_url':
            return /^https:\/\/overcast\.fm\/(itunes\d+\/[a-z0-9\-]+|\+[A-Za-z0-9]+)$/.test(url)

        case 'radio_public_url':
            if (url.includes("radiopublic")) {
                return true
            }
            break;
        case 'youtube_music_url':
            return /^https:\/\/music\.youtube\.com\/(playlist\?list=[\w-]+(?:&[\w-]+=[\w-]+)*|channel\/[\w-]+|podcast\/[\w-]+|watch\?v=[\w-]+(?:&[\w-]+=[\w-]+)*)$/.test(url);

        case 'youtube_url':
            // Supports: watch URLs, shorts, playlists (with additional query params like &si=), @usernames, channels, and youtu.be short URLs
            return /^https:\/\/(www\.)?youtube\.com\/((watch\?v=[\w-]+(&[\w-]+=[\w-]+)*)|(shorts\/[\w-]+)|(playlist\?list=[\w-]+(&[\w-]+=[\w-]+)*)|(@[\w.\-]+)|(channel\/[\w\-]+))(\?.*)?$|^https:\/\/youtu\.be\/[\w-]+(\?.*)?$/.test(url);

        // Social Media Platforms
        case 'instagram_url':
            // Supports: https://instagram.com/username or https://www.instagram.com/username
            return /^https:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9_.]+\/?(\?.*)?$/.test(url);

        case 'x_url':
            // Supports: https://x.com/username or https://twitter.com/username (legacy)
            return /^https:\/\/(www\.)?(x\.com|twitter\.com)\/[a-zA-Z0-9_]+\/?(\?.*)?$/.test(url);

        case 'facebook_url':
            // Supports: https://facebook.com/pagename or https://www.facebook.com/pagename
            return /^https:\/\/(www\.)?facebook\.com\/[a-zA-Z0-9.]+\/?(\?.*)?$/.test(url);

        case 'linkedin_url':
            // Supports: https://linkedin.com/in/username or https://linkedin.com/company/companyname
            return /^https:\/\/(www\.)?linkedin\.com\/(in|company)\/[a-zA-Z0-9\-]+\/?(\?.*)?$/.test(url);

        case 'tiktok_url':
            // Supports: https://tiktok.com/@username
            return /^https:\/\/(www\.)?tiktok\.com\/@[a-zA-Z0-9_.]+\/?(\?.*)?$/.test(url);

        case 'custom_url':
            try {
                const parsed = new URL(url);
                // Only allow https protocol
                if (parsed.protocol !== "https:") {
                    return false;
                }
                
                // Require a proper domain structure with at least one dot and valid TLD
                const hostname = parsed.hostname;
                if (!hostname || hostname.length === 0) {
                    return false;
                }
                
                // Check for invalid characters in the hostname
                if (/[^a-zA-Z0-9\-\.]/.test(hostname)) {
                    return false;
                }
                
                // Must have at least one dot and a valid TLD (at least 2 characters)
                const domainParts = hostname.split('.');
                if (domainParts.length < 2) {
                    return false;
                }
                
                // Check that TLD is at least 2 characters
                const tld = domainParts[domainParts.length - 1];
                if (tld.length < 2) {
                    return false;
                }
                
                // Basic domain validation - each part should be alphanumeric with optional hyphens
                const domainPartRegex = /^[a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?$/;
                for (let i = 0; i < domainParts.length; i++) {
                    if (!domainPartRegex.test(domainParts[i])) {
                        return false;
                    }
                }
                
                // Validate the pathname - should only contain valid URL characters
                const pathname = parsed.pathname;
                if (pathname && pathname.length > 0) {
                    // Check for invalid characters in path (spaces, brackets, etc.)
                    // Allow: letters, numbers, hyphens, underscores, dots, slashes, percent encoding
                    if (/[^\w\-\.\/%]/.test(pathname)) {
                        return false;
                    }
                }
                
                // Validate the search/query string if present
                const search = parsed.search;
                if (search && search.length > 0) {
                    // Check for invalid characters in query string
                    // Allow: letters, numbers, hyphens, underscores, dots, slashes, question marks, equals, ampersands, percent encoding
                    if (/[^\w\-\.\/\?=&%]/.test(search)) {
                        return false;
                    }
                }
                
                // Validate the hash if present
                const hash = parsed.hash;
                if (hash && hash.length > 0) {
                    // Check for invalid characters in hash
                    // Allow: letters, numbers, hyphens, underscores, dots, slashes, hash symbols, percent encoding
                    if (/[^\w\-\.\/#%]/.test(hash)) {
                        return false;
                    }
                }
                
                return true;
            } catch (error) {
                // If URL parsing fails (e.g., invalid protocol like "htt://"), it's invalid
                console.log('URL validation error:', error.message, 'for URL:', url);
                return false;
            }
    }
    return false;
}
